import { render, staticRenderFns } from "./BenefitBigNumbers.vue?vue&type=template&id=d4d4ae9c&scoped=true"
import script from "./BenefitBigNumbers.vue?vue&type=script&lang=js"
export * from "./BenefitBigNumbers.vue?vue&type=script&lang=js"
import style0 from "./BenefitBigNumbers.vue?vue&type=style&index=0&id=d4d4ae9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d4ae9c",
  null
  
)

export default component.exports